import React from "react";
import { Text, FormFieldTextProps } from "./Text";

export interface FormFieldIntegerProps
  extends Omit<FormFieldTextProps, "inputType" | "onChangeField"> {
  step?: number;
  onChangeField: (id: string, value: number | null) => void;
}

export const Integer: React.FC<FormFieldIntegerProps> = ({
  onChangeField,
  id,
  step = 1,
  ...props
}) => {
  const handleChange = (fieldId: string, value: string | null) => {
    if (value === null || value === "") {
      onChangeField(fieldId, null);
      return;
    }
    const parsed = parseInt(value, 10);
    onChangeField(fieldId, isNaN(parsed) ? null : parsed);
  };

  return (
    <Text
      {...props}
      id={id}
      onChangeField={handleChange as any}
      value={props.value != null ? String(props.value) : null}
      inputType="number"
    />
  );
};

Integer.displayName = "FormField.Integer";
